import { withErrorBoundary } from "@client/components/utils/ErrorBoundary";
import { RouteScroller } from "@client/components/utils/RouteScroller";
import { cn } from "@client/utils/cn";

export const Page = withErrorBoundary(
  ({
    className,
    containerClassName,
    title,
    description,
    cta,
    breadcrumbs,
    spacing = "default",
    children,
  }: {
    className?: string;
    containerClassName?: string;
    title?: string;
    description?: string;
    cta?: React.ReactNode;
    breadcrumbs?: React.ReactNode;
    spacing?: "default" | "compact";
    children?: React.ReactNode;
  }) => (
    <RouteScroller>
      <div
        className={cn(
          "relative flex-1 mx-auto w-full max-w-4xl px-4 md:px-8 flex flex-col gap-4 md:gap-6 overflow-x-hidden",
          spacing === "compact" ? "py-6 md:py-8" : "py-12 md:py-24",
          containerClassName,
        )}
      >
        {breadcrumbs}
        {(title || cta) && (
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
            <div className="min-w-0">
              <h1
                data-slot="page-title"
                className="text-2xl font-bold [overflow-wrap:anywhere]"
              >
                {title}
              </h1>
              {description && (
                <p className="text-xs text-muted-foreground">{description}</p>
              )}
            </div>
            {cta}
          </div>
        )}
        <div className={cn("flex-1", className)}>{children}</div>
      </div>
    </RouteScroller>
  ),
);
